import { Component, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { TOGGLE_MODE } from "../../redux/actions/constants";
import { logOutUserAction } from "../../redux/actions/userActions";
import IdleTimer from "../../utils/IdleTimer";
import DarkLightMode from "../common-components/DarkLightMode";
import HamburgerMenu from "./HamburgerMenu";

const SideMenu = ({ children }) => {
    const {
        isDarkMode,
        userInfo: {
            accountInfo: { accountName }
        }
    } = useSelector(
        (state) => state.persistedReducer,
        (oldValue, newValue) => {
            if (
                oldValue.isDarkMode !== newValue.isDarkMode ||
                oldValue.userInfo.accountInfo.accountName !==
                    newValue.userInfo.accountInfo.accountName
            ) {
                return false;
            }
            return true;
        }
    );
    const menubarItems = [
        {
            itemName: "Homepage",
            icon: "/icons/homepage.png",
            path: "/"
        },
        // { itemName: "Trade", icon: "/icons/stock.png", path: "/trade" },
        {
            itemName: "Charts",
            icon: "/icons/line-chart.png",
            path: "/charts"
        },
        {
            itemName: "Programs Status",
            icon: "/icons/switch.png",
            path: "/programs-status"
        },
        {
            itemName: "settings",
            icon: "/icons/settings-light.png",
            path: "/settings"
        },

        {
            itemName: "Dashboard",
            icon: "/icons/dashboard.png",
            path: "/dashboard"
        },
        {
            itemName: "Profile",
            icon: "/icons/profile.png",
            path: "/profile"
        },
        {
            itemName: "Currencies Details",
            icon: "/icons/exchange.png",
            path: "/currenciesDetails"
        },
        {
            itemName: "Log out",
            icon: "/icons/log-out.png",
            path: "/logout"
        }
    ];

    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        if (!accountName) {
            navigate("/login");
        }
    }, [accountName]);
    useEffect(() => {
        const timer = new IdleTimer({
            timeOut: 3600,
            onTimeOut: () => {
                dispatch(logOutUserAction());
            },
            onExpired: () => {
                dispatch(logOutUserAction());
            }
        });

        return () => {
            timer.cleanUp();
        };
    }, []);
    return (
        <div className=" flex min-h-full flex-col sm:flex-row">
            <ul
                className={`flex-1 hidden sm:flex  sm:flex-col sm:items-center sm:px-2 ${
                    isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
                } `}>
                {menubarItems.map((mb, index) => {
                    const { itemName, icon, path } = mb;
                    return (
                        <li
                            key={index}
                            className="flex flex-col justify-center items-center list-none text-center sm:mt-4 w-full cursor-pointer">
                            <img
                                className=" w-6"
                                src={icon}
                                alt=""
                                onClick={() => navigate(path)}
                            />
                            <h6 className="text-vsm">{itemName}</h6>
                        </li>
                    );
                })}
                <DarkLightMode
                    img={{
                        className: "mt-4 max-w-10 cursor-pointer",
                        src: `/icons/${isDarkMode ? "night.png" : "light.png"}`
                    }}
                    toggleMode={() => dispatch({ type: TOGGLE_MODE })}
                />
            </ul>
            <HamburgerMenu />

            <div className="w-full min-h-screen flex justify-evenly ">
                <Outlet />
            </div>
        </div>
    );
};

export default SideMenu;
